if (!customElements.get('rtd-course-selector')) {
  customElements.define(
    'rtd-course-selector',
    class RtdCourseSelector extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.offeringTransition = window.RtdOfferingTransition
          ? new window.RtdOfferingTransition(this)
          : null;
        this.coursePanels = Array.from(this.querySelectorAll('[data-course-panel]'));
        this.activeCoursePanel = this.querySelector('[data-course-panel]:not([hidden])');

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));

        const requestedCourse = new URLSearchParams(window.location.search).get('course');
        if (requestedCourse) this.selectCourse(requestedCourse, { animate: false });

        if (this.activeCoursePanel) {
          this.selectFormat(this.activeCoursePanel, this.activeCoursePanel.dataset.defaultFormat, {
            animate: false,
          });
        }
      }

      onClick(event) {
        const courseButton = event.target.closest('[data-course-tab]');
        if (courseButton && this.contains(courseButton)) {
          this.selectCourse(courseButton.dataset.courseTab);
          return;
        }

        const formatButton = event.target.closest('[data-format-tab]');
        if (formatButton && this.contains(formatButton)) {
          const coursePanel = formatButton.closest('[data-course-panel]');
          if (coursePanel) this.selectFormat(coursePanel, formatButton.dataset.formatTab);
        }
      }

      onChange(event) {
        const locationSelect = event.target.closest('[data-location-select]');
        if (locationSelect && this.contains(locationSelect)) this.selectLocation(locationSelect);
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        const tab = event.target.closest('[role="tab"]');
        const tabList = tab?.closest('[role="tablist"]');
        if (!tabList) return;

        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(tab);
        if (currentIndex === -1) return;

        event.preventDefault();
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        tabs[nextIndex].focus();
        tabs[nextIndex].click();
      }

      selectCourse(courseId, { animate = true } = {}) {
        const nextCoursePanel = this.coursePanels.find((panel) => panel.dataset.coursePanel === courseId);
        if (!nextCoursePanel) return;

        this.querySelectorAll('[data-course-tab]').forEach((button) => {
          const selected = button.dataset.courseTab === courseId;
          button.classList.toggle('is-active', selected);
          button.classList.toggle('button--secondary', !selected);
          button.setAttribute('aria-selected', String(selected));
          button.setAttribute('tabindex', selected ? '0' : '-1');
        });

        if (nextCoursePanel === this.activeCoursePanel) return;

        this.selectFormat(nextCoursePanel, nextCoursePanel.dataset.defaultFormat, { animate: false });
        this.showPanel(this.coursePanels, nextCoursePanel, { animate: animate && Boolean(this.activeCoursePanel) });
        this.activeCoursePanel = nextCoursePanel;
      }

      selectFormat(coursePanel, format, { animate = true } = {}) {
        coursePanel.querySelectorAll('[data-format-tab]').forEach((button) => {
          const selected = button.dataset.formatTab === format;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', String(selected));
          button.setAttribute('tabindex', selected ? '0' : '-1');
        });

        const formatPanels = Array.from(coursePanel.querySelectorAll('[data-format-panel]'));
        const nextFormatPanel = formatPanels.find((panel) => panel.dataset.formatPanel === format);
        if (!nextFormatPanel) return;

        const currentFormatPanel = formatPanels.find((panel) => !panel.hidden);
        this.showPanel(formatPanels, nextFormatPanel, {
          animate: animate && currentFormatPanel && currentFormatPanel !== nextFormatPanel,
        });

        if (format === 'in-person') {
          const locationSelect = nextFormatPanel.querySelector('[data-location-select]');
          if (locationSelect) this.selectLocation(locationSelect);
        }
      }

      showPanel(panels, nextPanel, { animate = true } = {}) {
        const inactivePanels = panels.filter((panel) => panel !== nextPanel);

        if (this.offeringTransition) {
          this.offeringTransition.hide(inactivePanels);
          this.offeringTransition.show(nextPanel, { animate });
          return;
        }

        inactivePanels.forEach((panel) => {
          panel.hidden = true;
        });
        nextPanel.hidden = false;
      }

      selectLocation(locationSelect) {
        const formatPanel = locationSelect.closest('[data-format-panel="in-person"]');
        if (!formatPanel) return;

        formatPanel.querySelectorAll('[data-location-group]').forEach((group) => {
          group.hidden = group.dataset.locationGroup !== locationSelect.value;
        });
      }
    }
  );
}
